import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

function LoaderButton(props) {
  return (
    <>
      <Button className="add-btn Mom-btn filter-height" disabled>
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />{" "}
       <p>
          &nbsp; Processing...
          </p>
      </Button>
    </>
  );
}

export default LoaderButton;
